.page {
    max-width: 560px;
}

.header {
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-small);
    margin: 0 0 28px;
}

.heading {
    margin: 0;
}

.headingRow {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--exo-spacing-small);
}

.headingActions {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-x-small);
}

.deleteConfirmRow {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: var(--exo-spacing-small);
}

.form {
    display: contents;
}

/* Fields */

.fields {
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-medium);
}

.field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.hint {
    margin: 0;
    font-size: var(--exo-font-size-micro);
}

/* Actions */

.actions {
    gap: var(--exo-spacing-small);
    display: flex;
    justify-content: flex-end;
    padding: calc(var(--exo-spacing-standard) - var(--exo-spacing-3x-small)) var(--exo-spacing-none);
}

.footerActions {
    border-top: var(--exo-spacing-4x-small) solid var(--exo-color-border-secondary);
    margin: var(--exo-spacing-none) var(--exo-spacing-medium);
}

.cancelButton {
    font-family: inherit;
    font-size: var(--exo-font-size-x-small);
    font-weight: 500;
    line-height: inherit;
    color: var(--exo-color-font);
    text-decoration: none;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
}

.deleteConfirmText {
    margin-right: auto;
    font-size: var(--exo-font-size-x-small);
    font-weight: 500;
    color: var(--exo-color-font);
}

/* Credentials */

.credentials {
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-standard);
    padding: var(--exo-spacing-standard);
    border: 0;
    border-radius: 8px;
    background: var(--exo-color-background-secondary);
}

.credentialField {
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-3x-small);
}

.credentialLabel {
    font-size: var(--exo-font-size-micro);
    font-weight: var(--exo-font-weight-regular);
    color: var(--exo-color-font-secondary);
}

.credentialValue {
    display: flex;
    align-items: center;
    gap: 6px;
}

.credentialCode {
    font-family: inherit;
    font-size: var(--exo-font-size-small);
    word-break: break-all;
    color: var(--exo-color-font);
}

.copyButton {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--exo-spacing-2x-small);
    border: none;
    background: none;
    cursor: pointer;
    color: var(--exo-color-brand);
    border-radius: 4px;
}

.copyButton:hover {
    background: var(--exo-color-background-tertiary);
}

/* Section heading */

.sectionHeading {
    margin: 0;
    font-size: var(--exo-font-size-small);
    font-weight: var(--exo-font-weight-semi-bold);
    color: var(--exo-color-font);
}

/* Error */

.saveError {
    margin-bottom: var(--exo-spacing-x-large);
    display: block;
}
